import { render, staticRenderFns } from "./Onhold.vue?vue&type=template&id=23062e90&scoped=true&"
import script from "./Onhold.vue?vue&type=script&lang=js&"
export * from "./Onhold.vue?vue&type=script&lang=js&"
import style0 from "./Onhold.vue?vue&type=style&index=0&id=23062e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23062e90",
  null
  
)

export default component.exports